module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bind"
  }, [_c('mt-header', {
    attrs: {
      "title": "绑定手机号"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hrefLogin($event)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(this.nickname) + ",你好")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "input_group"
  }, [_c('icon', {
    attrs: {
      "name": "mobile"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel",
      "name": "phone",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }, _vm.phoneChange]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input_group"
  }, [_c('icon', {
    attrs: {
      "name": "envelope-open-o"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "id": "codeVal",
      "name": "code",
      "placeholder": "请填写手机验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    ref: "getCode",
    staticClass: "sendCode",
    attrs: {
      "type": "button",
      "disabled": _vm.canGet
    },
    on: {
      "click": function($event) {
        return _vm.countDown()
      }
    }
  }, [_vm._v("获取验证码")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input_group"
  }, [_c('icon', {
    attrs: {
      "name": "lock"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "pw",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "请填写密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "look",
    class: {
      'lookType': !_vm.lookType
    },
    attrs: {
      "name": "eye"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.seePw()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.bindWeChatNew
    }
  }, [_vm._v("注册新账号")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.bindWeChatOld
    }
  }, [_vm._v("绑定已有账号")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eaffe92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/accountBind.vue
// module id = 1280
// module chunks = 1